module.exports = __webpack_public_path__ + "img/caja-maynas.c0ba3eb3.svg";